export const getId = () => {
  const path = window.location.pathname.split('/').filter(Boolean);
  return path[path.length - 1];
};
